export default __webpack_public_path__ + "static/media/Bracelets of the Primal Spirit.d16286d6.jpg";